module.exports = __webpack_public_path__ + "media/images/smart_phone/mie-5c2314772805560c0958f84ccb3ec20f.gif";